<script>
export default {
  name: 'rating',
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      tasks: [],
      winners: [],
      tab: null,
      taskTab: null,
      tableHeaders: [
        { text: '№ п/п', value: 'order_number', sortable: false, align: 'left', width: 100, class: 'order-number-th' },
        { text: 'ФИО', value: 'fio', sortable: false, align: 'start', class: 'fio-th' },
        { text: 'Компания-партнер', value: 'dealer_name', sortable: false, align: 'start', class: 'fio-th' },
        { text: 'Кол-во баллов', value: 'bonuses', sortable: false, align: 'end', class: 'status-bonuses-th' },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    currentTask() {
      return this.tasks[this.tab];
    },
  },
  watch: {
    currentTask(task) {
      console.log(this.tasks);
      if (this.task === null) {
        task = (this.tasks) ? this.tasks[0] : null;
      }
      task && this.$store.getters.axl
        .post('tasks/api/task/winners-list', { task_id: task.id }).then((response) => {
          const { winners } = response.data;
          winners.forEach((winner, index) => {
            winner.order_number = index + 1;
          });
          this.winners = winners;
        });
    },
  },
  methods: {
    rowClass(item) {
      if (item.profile_id === this.user.profile_id) {
        return 'current-user';
      }
      return '';
    },
    setCurrentUserPage() {
      this.taskTab = 0;
      const winnerIndex = this.winners
        .findIndex(winner => winner.profile_id === this.user.profile_id);
      this.currentPage = (winnerIndex + 1) / this.itemsPerPage;
    },
    pageChange(newPage) {
      this.currentPage = newPage;
    },
  },
  created() {
    this.$store.getters.axl
      .post('tasks/api/task/history-list', { type_id: 1, profile_id: this.user.profile_id }).then((response) => {
        const { tasks } = response.data;
        tasks.sort((a, b) => Number(b.is_actual) - Number(a.is_actual));
        this.tasks = tasks;
      });
  },
};
</script>

<template>
  <div class="page-content--body competitions-info">
    <div v-if="tasks && tasks.length" class="page-content--body-right">

      <v-tabs v-model="tab" class="promo-tabs-top mb-4">
        <v-tab v-for="task in tasks" :key="task.id" :tab-value="task.id">{{ task.title }}</v-tab>
      </v-tabs>

      <div class="tabs-wrap mb-4">
        <v-tabs v-model="taskTab" class="stout--tabs _competitions">
          <v-tab tab-value="info">Информация</v-tab>
          <v-tab tab-value="winners">Победители</v-tab>
        </v-tabs>

        <v-btn class="btn-blue btn-small" color="warning" @click="setCurrentUserPage">Показать мою позицию</v-btn>
      </div>

      <v-card>
        <div v-if="currentTask && taskTab === 0" class="competitions-info__content">
          <p class="card-text" v-html="currentTask.description" />
        </div>


        <v-card-text v-else class="competitions-card">
          <v-data-table
            :headers="tableHeaders"
            :item-class="rowClass"
            :items="winners"
            :items-per-page="itemsPerPage"
            :page="currentPage"
            class="competitions-table"
            no-data-text="Нет участников"
            @update:page="pageChange"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
    <div v-else> упс </div>
  </div>

</template>

<style lang="scss" scoped>
::v-deep {
  .current-user {
    background-color: beige;
  }
}

.tabs-wrap {
  display: flex;
  justify-content: space-between;

  @media (max-width: 549px) {
    flex-direction: column;

    .v-tabs {
      margin-bottom: 16px;
    }
  }
}

.competitions-info__content {
  padding: 24px;
  color: #000;

  @media (max-width: 576px) {
    padding: 16px;
  }

  .card-title {
    margin-bottom: 12px;
  }

  ul {
    margin-bottom: 20px;
    padding-left: 0;

    li {
      list-style: none;
      position: relative;
      padding-left: 12px;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 8px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #0464AC;
        margin-right: 4px;
      }

    }
  }
}
</style>
